import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attr-number',
  templateUrl: './attr-number.component.html',
  styleUrls: ['./attr-number.component.scss'],
  standalone: false,
})
export class AttrNumberComponent implements OnInit {
  @Input() propertyId: string;
  @Input() caption: string;
  @Input() value: number;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;

  constructor() {}

  ngOnInit(): void {}
}
